export const iconFontAwesomeDisasterCrisisPersonDrowning = (
	<i className="fa-solid fa-person-drowning"></i>
);
